import { createFileRoute } from "@tanstack/react-router";

import People from "@/containers/People";

export const Route = createFileRoute("/_app/(people)/people/")({
  component: () => <People />,
});
